export default {
    header: 'บันทึกการใช้งาน',
    searchText: 'ค้นหารหัสพนักงาน / ชื่อผุ้ใช้งาน',
    search: 'ค้นหา',
    dateTime: 'วันและเวลา',
    employeeId: 'รหัสพนักงาน',
    userName: 'ชื่อผู้ใช้งาน',
    change: 'แอคชั่น',
    menu: 'เมนู',
    action: ''
}
